import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactLoading from "react-loading";
import UserImage from "../../assets/images/user.png";
import { formattedPrice } from "../../helpers/MainHelper";

/**
 * UserAccountPanel — Sidebar kullanıcı bilgileri ve istatistik paneli
 * NavbarMenu'dan çıkartıldı.
 */
const UserAccountPanel = ({ userInfo, totalService, totalCustomers, totalSuppliers, totalRevenue, isLoad }) => {
  return (
    <div className="user-account">
      <img
        src={userInfo ? (userInfo.profile_photo_url) : UserImage}
        className="rounded-circle user-photo"
        alt="User Profile"
      />
      <Dropdown>
        <span>{userInfo && userInfo.service.name}</span>
        <Dropdown.Toggle variant="none" as="a" id="dropdown-basic" className="user-name">
          <strong>{userInfo && (userInfo.name + ' ' + userInfo.surname)}</strong>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-right account">
          <Dropdown.Item>
            <Link to={`/user-detail/${userInfo && (userInfo.id)}`}>
              <i className="icon-user"></i>Profil
            </Link>
          </Dropdown.Item>
          <Dropdown.Item>
            <Link to="/settings/business">
              <i className="icon-settings"></i>Ayarlar
            </Link>
          </Dropdown.Item>
          <li className="divider"></li>
          <Dropdown.Item href="login">
            <i className="icon-power"></i>Çıkış
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <hr />
      <ul className="row list-unstyled">
        <li className="col-4">
          <label className="font-weight-bold text-cyan"><small><Link to="/services">Servisler</Link></small></label>
          <h6>{isLoad ? totalService : (<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />)}</h6>
        </li>
        <li className="col-4">
          <label className="font-weight-bold text-cyan"><small><Link to="/customers-all">Müşteriler</Link></small></label>
          <h6>{isLoad ? totalCustomers : (<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />)}</h6>
        </li>
        <li className="col-4">
          <label className="font-weight-bold text-cyan"><small><Link to="/suppliers">Tedarikçiler</Link></small></label>
          <h6>{isLoad ? totalSuppliers : (<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />)}</h6>
        </li>
      </ul>
      <ul className="row list-unstyled">
        <li className="col-4">
          <label className="font-weight-bold text-cyan"><small>Tamamlanan Net Ciro</small></label>
          <h6>{isLoad ? formattedPrice(totalRevenue) : (<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />)}</h6>
        </li>
      </ul>
    </div>
  );
};

export default UserAccountPanel;
